<template>
  <div>
    <DetailSheetHeader
      :title="selectedWaypointGroup?.title || 'Waypoint group'"
      :subtitle="waypointCountLabel"
      show-back
      @back="backClicked"
    />

    <div class="p-3">
    <button @click="printGroup" class="btn btn-secondary mb-3">PRINT</button>

    <div v-for="waypoint in uniqueWaypoints" :key="waypoint.clientId">
      <div class="d-flex justify-content-between">
        <span>
          <p class="m-0">{{waypoint.title}}</p>
          <p><small class="text-muted">{{waypoint.createdAt}}</small></p>
        </span>
        <span class="float-right d-none d-flex justify-content-center">
          <button class="btn btn-xs btn-secondary" style="max-height: 34px;" @click="showClicked(waypoint)">SHOW</button>
        </span>
      </div>
      <hr class="my-2">
    </div>
    <span class="float-right d-none d-flex pb-3 justify-content-center">
      <button class="btn btn-xs btn-danger mr-2"  @click="deleteWaypointGroup">Delete Group</button>
      <button class="btn btn-xs btn-secondary" @click="exportGroupToGPX">Export all waypoints to GPX</button>
    </span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import DetailSheetHeader from '../../../utils/shared_components/detail_sheet/DetailSheetHeader.vue';
import { uniqueWaypointsById, waypointCountLabel } from '../../../utils/helpers/waypointDetails';

export default defineComponent({
  components: { DetailSheetHeader },
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      selectedWaypointGroup: (state) => state.waypoints.selectedWaypointGroup,
    }),
    waypointCountLabel() {
      return waypointCountLabel(this.uniqueWaypoints.length);
    },
    uniqueWaypoints() {
      return uniqueWaypointsById(this.selectedWaypointGroup?.waypoints);
    },
  },
  methods: {
    backClicked() {
      this.$store.commit('waypoints/popPage');
    },
    showClicked(waypoint) {
      this.$store.dispatch('waypoints/showWaypointOnMap', waypoint);
    },
    printGroup() {
      window.location.href = `/print-maps?data_ids[]=${this.selectedWaypointGroup.id}&data_types[]=WaypointGroup`;
    },
    exportGroupToGPX() {
      this.$store.dispatch('waypoints/exportSelectedWaypointGroupToGPX');
    },
    deleteWaypointGroup() {
      this.$store.dispatch('waypoints/destroySelectedWaypointGroup');
    },
  },
});
</script>

<style scoped>
</style>
